/**
 * @description: 获取URL参数值
 * @param name:URL参数名
 * @return  URL参数值
 */
export function getUrlParam(name){
	var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if (r!=null)
		return unescape(r[2]); 
	return null;
}


// WEBPACK FOOTER //
// ./web/js/utils/router.js